var map = {
	"./blogs/back-press-handling-in-android-13.mdx": [
		1648,
		648
	],
	"./blogs/compose-effect-handlers.mdx": [
		9320,
		320
	],
	"./blogs/internal-working-of-suspend-function.mdx": [
		2388,
		388
	],
	"./blogs/kotlin-annotations.mdx": [
		2676,
		56
	],
	"./blogs/render-markdown-in-react.mdx": [
		2580,
		580
	],
	"./blogs/room-tutorial-part-1.mdx": [
		9872,
		252
	],
	"./blogs/room-tutorial-part-2.mdx": [
		1608,
		608
	],
	"./blogs/room-tutorial-part-3.mdx": [
		6564,
		564
	],
	"./blogs/room-tutorial-part-4.mdx": [
		7180,
		180
	],
	"./blogs/syntax-styling-using-react-syntax-highlighter.mdx": [
		1472,
		472
	],
	"./reflections/emotional-agility.mdx": [
		2896,
		896
	],
	"./reflections/loneliness.mdx": [
		444,
		444
	],
	"./reflections/pursuit-of-happiness.mdx": [
		9196,
		196
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2852;
module.exports = webpackAsyncContext;